module.exports = __webpack_public_path__ + "images/pro/icon-pro-features@2x-d625a850080280154cd4acf9eb37424b.png";